import './styles/index.scss';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './features/auth/login';
import React, { useContext } from 'react';
import { AppContext, AppState } from './state/app-state';
import { Header } from './components/header/header';
import { Internationalization } from './features/internationalization';
import { useLocation } from 'react-router';
import { Settings } from './features/settings';
import { GeoInfo } from './features/geo-info';
import { MapServers } from './features/geo-info/map-servers';
import { MapServerEditor } from './features/geo-info/map-server-editor';
import { ToastContainer } from 'react-toastify';
import { MapServices } from './features/geo-info/map-services';
import { MapServiceEditor } from './features/geo-info/map-service-editor';
import { MapLayers } from './features/geo-info/map-layers/map-layers';
import { MapLayerEditor } from './features/geo-info/map-layers/map-layer-editor';
import { FieldsEditor } from './features/geo-info/map-layers/tabs/fields-editor';
import { LayerGroups } from './features/geo-info/layer-groups';
import { Reports } from './features/reports';
import { Configurations } from './features/config';
import { LayerGroupEditor } from './features/geo-info/layer-group-editor';
import { MapLayerImport } from './features/geo-info/map-layers/map-layer-import';
import { TenantContext } from './state/tenant-state';

const App = (): JSX.Element => {
  const location = useLocation();
  const appContext = useContext(AppContext) as AppState;
  const tenantContext = useContext(TenantContext);
  const tenant = tenantContext.current;

  if (appContext?.authenticated === undefined) {
    return <div>Loading...</div>;
  }

  if (!appContext?.authenticated) {
    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  if (!tenant?.id) {
    return <div>Loading...</div>;
  }

  if (location.pathname === '/') {
    return <Navigate to="/configurations" />;
  }

  return (
    <div>
      <Header />
      <div className="content">
        <ToastContainer />
        <Routes>
          <Route path="/internationalization/*" element={<Internationalization />} />
          <Route path="/settings/*" element={<Settings />} />
          <Route path="/geo-info/*" element={<GeoInfo />} />
          <Route path="/map-servers" element={<MapServers />} />
          <Route path="/map-servers/:id" element={<MapServerEditor />} />
          <Route path="/map-services" element={<MapServices />} />
          <Route path="/map-services/:id" element={<MapServiceEditor />} />
          <Route path="/map-layers" element={<MapLayers />} />
          <Route path="/map-layers/import" element={<MapLayerImport />} />
          <Route path="/map-layers/:id/fields/:fieldId/*" element={<FieldsEditor />} />
          <Route path="/map-layers/:id/*" element={<MapLayerEditor />} />
          <Route path="/layer-groups" element={<LayerGroups />} />
          <Route path="/layer-groups/:id" element={<LayerGroupEditor />} />
          <Route path="/reports/*" element={<Reports />} />
          <Route path="/configurations/*" element={<Configurations />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;
